import React from 'react';
import { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getShapeDimensions } from '../../../../../redux/shape/shape-reducer';
import ColorMenu from './ColorMenu.jsx';
import './StrokeMenu.scss';

export default function StrokeMenu(props) {
    const [strokeWidth, setStrokeWidth] = useState(0);
    const [isStrokeColorBtnActive, setIsStrokeColorBtnActive] = useState(false);
    const [shapeStrokeCurrentColor, setShapeStrokeCurrentColor] = useState('#000');

    // const reticleId = useSelector(getShapeDimensions);

    // const handlerStrokeNone = () => {
    //     if (props.selectedShape) {
    //         props.selectedShape.attr({'stroke': 'none'});
    //     }
    // }

    const handlerStrokeSolid = () => {
        setIsStrokeColorBtnActive(false);

        if (props.selectedShapes && props.selectedShapes.length > 1) {
            props.selectedShapes.forEach(shape => {
                return shape.attr({'stroke-dasharray': 'none', 'stroke-width': strokeWidth});
            })
        } else {
            if (props.selectedShape) {
                props.selectedShape.attr({'stroke-dasharray': 'none', 'stroke-width': strokeWidth});
            }
        }
    }

    const handlerStrokeDash = () => {
        setIsStrokeColorBtnActive(false);

        if (props.selectedShapes && props.selectedShapes.length > 1) {
            props.selectedShapes.forEach(shape => {
                return shape.attr({'stroke-dasharray': '10, 5'});
            })
        } else {
            if (props.selectedShape) {
                props.selectedShape.attr({'stroke-dasharray': '10, 5'});
            }
        }
    }

    const handlerStrokeDot = () => {
        setIsStrokeColorBtnActive(false);

        if (props.selectedShapes && props.selectedShapes.length > 1) {
            props.selectedShapes.forEach(shape => {
                return shape.attr({'stroke-dasharray': '3, 3'});
            })
        } else {
            if (props.selectedShape) {
                props.selectedShape.attr({'stroke-dasharray': '3, 3'});
            }
        }
    }

    const handlerStrokeDashDot = () => {
        setIsStrokeColorBtnActive(false);

        if (props.selectedShapes && props.selectedShapes.length > 1) {
            props.selectedShapes.forEach(shape => {
                return shape.attr({'stroke-dasharray': '10, 3, 3, 3'});
            })
        } else {
            if (props.selectedShape) {
                props.selectedShape.attr({'stroke-dasharray': '10, 3, 3, 3'});
            }
        }
    }

    const handlerStrokeColor = () => {
        setIsStrokeColorBtnActive(!isStrokeColorBtnActive);
    }

    const handleShapeStrokeWidthRange = (e) => {
        setStrokeWidth(+e.target.value);

        if (props.selectedShapes && props.selectedShapes.length > 1) {
            props.selectedShapes.forEach(shape => {
                return shape.attr({'stroke-width': +e.target.value});
            })
        } else {
            if (props.selectedShape) {
                props.selectedShape.attr({'stroke-width': +e.target.value});
            }
        }
    }

    const handlerUpdateShapeCurrentColor = (color) => {
        setShapeStrokeCurrentColor(color);
    }

    useEffect(() => {
        if (props.selectedShapes && props.selectedShapes.length > 1) {
            setStrokeWidth(props.selectedShapes[0].attr('stroke-width'));
            setShapeStrokeCurrentColor(props.selectedShapes[0].attr('stroke'));
        } else {
            if (props.selectedShape) {
                setStrokeWidth(props.selectedShape.attr('stroke-width'));
                setShapeStrokeCurrentColor(props.selectedShape.attr('stroke'));
            }
        }
    }, [props.selectedShape])

    return (
        <section className='stroke-shape-menu-section' onClick={(e) => e.stopPropagation()}>
            <div className='stroke-menu_btns-block'>
                {/* <button className='stroke-menu-btn none-stroke-btn' onClick={handlerStrokeNone}></button> */}
                <button className='stroke-menu-btn solid-stroke-btn' onClick={handlerStrokeSolid}></button>
                <button className='stroke-menu-btn dash-stroke-btn' onClick={handlerStrokeDash}></button>
                <button className='stroke-menu-btn dot-stroke-btn' onClick={handlerStrokeDot}></button>
                <button className='stroke-menu-btn dash-dot-stroke-btn' onClick={handlerStrokeDashDot}></button>
                <button className='stroke-menu-btn color-stroke-btn' onClick={handlerStrokeColor}>
                    <span className='stroke-menu_current-color' style={{backgroundColor: '#fff', borderColor: shapeStrokeCurrentColor}}>
                        {isStrokeColorBtnActive &&
                            <ColorMenu selectedShape={props.selectedShape} selectedShapes={props.selectedShapes} isStrokeColor={true} updateIconColor={handlerUpdateShapeCurrentColor} />
                        }
                    </span>
                </button>
            </div>
            <div className='stroke-menu_range-block'>
                <p className='stroke-menu_input-label'>Stroke weigth</p>
                <div className='stroke-menu_input-block'>
                    <input type='range' className='stroke-menu_range' onChange={handleShapeStrokeWidthRange} min={0.1} max={30} step={0.1} value={strokeWidth}></input>
                    <input type='text' className='stroke-menu_input' value={strokeWidth} disabled></input>
                </div>
            </div>
        </section>
    )
}